import RedirectMyPath from './RedirectMyPath';

export default RedirectMyPath;
